export default __webpack_public_path__ + "static/media/r&b_soul.c31f383d.png";